import classNames from "classnames";
import PropTypes from "prop-types";
import { Fragment } from "react";
import { Button } from "../button";
import { Loader } from "../loader";
import styles from "./button-loader.styles.module.scss";

const propTypes = {
  ariaLabel: PropTypes.string,
  btnClass: PropTypes.oneOf([
    "btn-primary",
    "btn-secondary",
    "btn-tertiary",
    "primary-destructive-btn",
    "secondary-destructive-btn",
    "tertiary-destructive-btn",
    "secondary-dark-theme-btn",
  ]),
  btnRootClassName: PropTypes.string,
  children: PropTypes.any, // ReactNode | ReactNode[] | string
  disabled: PropTypes.bool,
  handleButtonClick: PropTypes.func,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  rootClassName: PropTypes.string,
  /** @deprecated no longer used, can be removed from any component passing prop */
  isTextCapitalizationOff: PropTypes.bool,
};

/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 */
const ButtonLoader = ({
  ariaLabel = "",
  btnClass = "btn-tertiary",
  btnRootClassName = "",
  children,
  disabled = false,
  handleButtonClick = (_event) => {},
  isLoading = false,
  onClick = (_event) => {},
  rootClassName = "",
}) => {
  const handleClick = (e) => {
    handleButtonClick(e);
    onClick(e);
  };
  return (
    <div className={classNames("gx-btn-loader", rootClassName, styles.root)}>
      <div className={styles.wrapper}>
        <Button
          ariaLabel={ariaLabel || null}
          disabled={disabled}
          onClick={handleClick}
          rootClassName={classNames(btnClass, btnRootClassName, isLoading ? styles.loading : styles.visible)}
        >
          {children}
        </Button>
        {isLoading && (
          <Fragment>
            <div className={classNames(btnClass, styles.loaderWrapper)} />
            <Loader btnClass={btnClass} source="button" />
          </Fragment>
        )}
      </div>
    </div>
  );
};

ButtonLoader.propTypes = propTypes;
export { ButtonLoader };
